import React from 'react';
import {
  Grid, Typography, Button, useMediaQuery
} from '@mui/material';

const AuthenticationIdentity = ({
  type,
  popupType,
  handleSubmitOtp,
  resendOtp,
  resendButtonDisable,
  buttonText
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  // Common message logic start here
  const getMessage = () => {
    if (popupType === "credit" || popupType === "funding") {
        const finalLine =
      popupType === "credit"
        ? "Credit Snapshot"
        : "Funding Snapshot";
      return (<>
        You Should Have Received{" "}
        {type === "phone"
          ? "A Text Message"
          : "An Email"}{" "} On Your Registered {" "}
        {type === "phone" ? "Phone Number":
          "Email ID"}
        {" "} Containing An Authentication Link To Verify Your Identity. Please Click The Link To Complete The Authentication Process. Once Authenticated, Click The Button Below To Proceed To Your {finalLine}.
      </>
      );} 
      
    return "";
  };
 // Common message logic end here
  const isFunding = popupType === "funding";

  return (
    <>
      <Grid container item xs={12} mb={2}>
        <Typography variant="body1" textAlign="center" fontWeight="bold">
          {getMessage()}
        </Typography>
      </Grid>

      {isFunding && (
        <Grid container item xs={12} justifyContent="center">
          <img
            src={require("../../assets/images/verificationPhone.png")}
            alt="Verification"
            style={{ width: "150px", objectFit: "cover" }}
          />
        </Grid>
      )}

      <Grid container item xs={12} justifyContent="center" mt={2}>
        <Button
          variant="contained"
          color={isFunding?"success":"primary"}
          onClick={handleSubmitOtp}
          sx={{
            backgroundColor: isFunding ? "#3FAC19" : undefined,
            minWidth: isMobile ? "200px" : "300px",
            fontSize: "16px",
            fontWeight: 700,
            borderRadius: "10px",
            ...(isFunding && {
              animation: "blink 1.5s infinite",
              "@keyframes blink": {
                "0%": { backgroundColor: "#3FAC19" },
                "50%": { backgroundColor: "#55cc28" },
                "100%": { backgroundColor: "#3FAC19" }
              }
              })
          }}
        >
          {isFunding
            ? 'NEXT'
            : 'Continue To View My FREE Credit Score'}
        </Button>
      </Grid>

      <Grid container item xs={12} justifyContent="center" mt={1} mb={2}>
        <Typography>Haven't Received The Authorization Link Yet?</Typography>&nbsp;&nbsp;
        <Button
          disabled={resendButtonDisable}
          onClick={resendOtp}
          variant="contained"
          color={isFunding ? "primary" : "success"}
          size="small"
          sx={{ minWidth: 100 }}
        >
          {buttonText}
        </Button>
      </Grid>
    </>
  );
};

export default AuthenticationIdentity;
